import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import InputField from "../../Utils/InputField";
import { LabelText } from "../../Utils/Input";

const ThresholdNotification = ({
  thresholds,
  addThreshold,
  toggleButton,
  handleThresholdChange,
  removeThreshold,
  handleChange,
  touched,
  errors,
  values,
  setFieldValue,
  isEdit,
  setThresholds,
  setTouched,
}) => {
  const [activeButtons, setActiveButtons] = useState([]);

  useEffect(() => {
    if (isEdit) {
      const newActiveButtons = thresholds?.map((threshold) =>
        threshold.thresholdType === "Percentage" ? 1 : 0
      );
      setActiveButtons(newActiveButtons);
    } else {
      setActiveButtons(
        thresholds?.map((threshold) =>
          threshold.thresholdType === "Percentage" ? 1 : 0
        )
      );
    }
  }, [thresholds, isEdit]);

  const handleAddThreshold = () => {
    const lastIndex = thresholds?.length - 1;
    if (lastIndex === -1 || isThresholdFilled(thresholds[lastIndex])) {
      addThreshold(thresholds, setThresholds, activeButtons, setActiveButtons);
    }
  };

  const handleClearCurrentThreshold = (index) => {
    // Clear only the current threshold's value
    const updatedThresholds = [...thresholds];
    updatedThresholds[index] = {
      ...updatedThresholds[index],
      thresholdValue: ''
    };
    setThresholds(updatedThresholds);
    setFieldValue(`thresholds[${index}].thresholdValue`, '');

    // Reset touched state for current threshold
    if (setTouched) {
      setTouched({
        ...touched,
        thresholds: {
          ...touched.thresholds,
          [index]: {
            ...touched.thresholds?.[index],
            thresholdValue: false,
          },
        },
      });
    }
  };

  const isThresholdFilled = (threshold) => {
    return threshold && threshold.thresholdValue && threshold.thresholdValue.toString().trim() !== '';
  };

  return (
    <Row className="mt-2">
      <Col lg={12}>
        <CardBody>
          <h5 className=" fw-bold">
            Threshold Notification{" "}
            <span className="rv-label-muted fw-light fs-6">
              (Configure absolute or percentage threshold notification values)
            </span>
          </h5>
          <div className="d-flex  align-items-center"></div>
          <LabelText
            htmlFor={"Enter Threshold Value"}
            displayText={"Enter Threshold Value"}
            classLabelName={"rv-label-muted fw-light fs-6"}
          />
          {thresholds?.map((threshold, index) => {
            const isCurrentThresholdFilled = isThresholdFilled(threshold);

            return (
              <Row key={index} className="mb-3">
                <Col lg={1} md={2} sm={2} xs={2} className="me-md-2 ">
                  <div
                    style={{
                      display: 'inline-flex',
                      border: '1px solid #dee2e6',
                      borderRadius: '6px',
                      overflow: 'hidden',
                      backgroundColor: 'white'
                    }}
                  >
                    <button
                      type="button"
                      style={{
                        border: 'none',
                        backgroundColor: activeButtons.length !== 0 && activeButtons[index] === 0 ? '#fd7545' : 'white',
                        color: activeButtons.length !== 0 && activeButtons[index] === 0 ? 'white' : '#6c757d',
                        padding: '8px 16px',
                        fontSize: '14px',
                        fontWeight: activeButtons.length !== 0 && activeButtons[index] === 0 ? '600' : '500',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        minWidth: '45px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRight: '1px solid #dee2e6',
                        borderTopLeftRadius: '1px',
                        borderBottomLeftRadius: '1px',
                        outline: 'none'
                      }}
                      onClick={() =>
                        toggleButton(
                          index,
                          0,
                          activeButtons,
                          setActiveButtons,
                          thresholds,
                          setThresholds
                        )
                      }
                    >
                      123
                    </button>
                    <button
                      type="button"
                      style={{
                        border: 'none',
                        backgroundColor: activeButtons[index] === 1 ? '#fd7545' : 'white',
                        color: activeButtons[index] === 1 ? 'white' : '#6c757d',
                        padding: '8px 16px',
                        fontSize: '14px',
                        fontWeight: activeButtons[index] === 1 ? '600' : '500',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        minWidth: '45px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderTopRightRadius: '1px',
                        borderBottomRightRadius: '1px',
                        outline: 'none'
                      }}
                      onClick={() =>
                        toggleButton(
                          index,
                          1,
                          activeButtons,
                          setActiveButtons,
                          thresholds,
                          setThresholds
                        )
                      }
                    >
                      %
                    </button>
                  </div>
                </Col>
                <Col lg={4} md={6} sm={6}>
                  <div className="d-flex align-items-center ms-2">
                    <div className="flex-grow-1">
                      <InputField
                        type="number"
                        name={`thresholds[${index}].thresholdValue`}
                        className={`rounded-1 ${
                          // Remove validation for first threshold (index === 0)
                          index > 0 && touched.thresholds?.[index]?.thresholdValue &&
                            errors.thresholds?.[index]?.thresholdValue
                            ? "is-invalid"
                            : ""
                          }`}
                        value={threshold?.thresholdValue}
                        placeholder={`Enter ${threshold?.thresholdType === "Fixed"
                            ? "threshold value"
                            : "percentage"
                          }`}
                        handleChange={(e) =>
                          handleThresholdChange(
                            index,
                            "thresholdValue",
                            e.target.value
                          )
                        }
                        invalid={
                          // Remove validation for first threshold (index === 0)
                          index > 0 && touched.thresholds?.[index]?.thresholdValue &&
                          errors.thresholds?.[index]?.thresholdValue
                        }
                        required
                      />
                    </div>

                    <div className="ms-2 d-flex align-items-center" style={{ minWidth: '60px' }}>
                      {/* Show Add and Clear buttons when current threshold is filled */}
                      {isCurrentThresholdFilled && (
                        <>
                          <i
                            className="mdi mdi-plus-circle-outline fs-5 text-primary me-2"
                            role="button"
                            onClick={handleAddThreshold}
                          ></i>
                          <i className="ri-close-line fw-bold align-middle fs-4 cross-icon-color"
                            role="button"
                            onClick={() => handleClearCurrentThreshold(index)}
                          ></i>
                        </>
                      )}

                      {index > 0 && !isCurrentThresholdFilled && (
                        <Link
                          to="#"
                          className="link-danger fs-5"
                          onClick={() =>
                            removeThreshold(index, setFieldValue, values)
                          }
                        >
                          <i
                            data-testid="delete"
                            className="ri-delete-bin-5-line"
                          ></i>
                        </Link>
                      )}
                    </div>
                  </div>
                  {index > 0 && errors.thresholds?.[index]?.thresholdValue &&
                    touched.thresholds?.[index]?.thresholdValue && (
                      <p className="text-danger">
                        {errors.thresholds[index]?.thresholdValue}
                      </p>
                    )}
                </Col>
              </Row>
            );
          })}
        </CardBody>
      </Col>
    </Row>
  );
};

export default ThresholdNotification;